<div class="container-fluid p-0 text-center mt-5">
    <i class="bi bi-exclamation-triangle-fill text-danger" style="font-size: 3rem;"></i>

    <p class="p-3 fs-5">
        {{ 'linkExpiredMsg' | propValue }}<a href="tel:800-794-3032" class="phone-link">(800)-794-3032</a>
        {{ 'linkExpiredMsgOr' | propValue }}<a href="tel:302-761-6576" class="phone-link">(302)-761-6576</a>
    </p>

</div>